<template>
  <div>
    <!-- <euros-header :titre="getTitre()" pathRetour="/logout" btnRetour="Déconnexion"></euros-header> -->
    <tab-bar currentActive="newpatient" @changeActive="changeTabbar"></tab-bar>
    <div class="d-flex flex-column h-100vh">
      <!-- <div>
        <tab-activites @changeActive="changeActivite" active="genou"></tab-activites>
      </div> -->
      <div class="container-fluid flex-grow-1 overflow-auto">
        <div class="row pt-4">
          <div class="col">
            <div class="position-relative">
              <div class="position-absolute" style="z-index: 2000; top: -10px; right: 0px">
                <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon" @click="finish"
                  style="width: 30px; height: 30px; min-height: 0">
                  <icon width="20" height="20" name="times"></icon>
                </div>
              </div>
            </div>
            <h1>ACTIVITÉS</h1>
            <h2>GENOU</h2>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <h3>PATIENT</h3>
            <div class="">
              <label class="mt-2 mb-0" for="name">Nom *</label>
              <m-form-text label="" v-model="patient.pa_name"></m-form-text>
            </div>
            <!-- <div class="">
              <label class="mt-2 mb-0" for="">Date de naissance</label>
              <m-form-text label="" v-model="patient.pa_birthdate" placeholder="jj/mm/aaaa"></m-form-text>
            </div> -->
            <div class="row">
              <div class="col">
                <label class="mt-2 mb-0" for="">Age</label>
                <m-form-text @input="calculate" type="number" label="" v-model="patient.pa_age"
                  placeholder=""></m-form-text>
              </div>
              <div class="col">
                <label class="mt-2 mb-0" for="">Sexe</label>
                <select class="custom-select mt-0" v-model="patient.pa_sex" @change="calculate">
                  <option v-for="(option, index) in itemsSex" :value="option.value" :key="'sex_' + index">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <label class="mt-2 mb-0" for="">Poids (en kg)</label>
                <m-form-text @input="calculate" class="mt-0" type="number" v-model="patient.pa_weight"></m-form-text>
              </div>
              <div class="col">
                <label class="mt-2 mb-0" for="">Taille (en cm)</label>
                <m-form-text @input="calculate" class="mt-0" type="number" v-model="patient.pa_height"></m-form-text>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="mt-2 mb-0" for="">Côté droit/gauche</label>
                <select class="custom-select mt-0" v-model="patient.pa_lateralite" @change="calculate">
                  <option v-for="(option, index) in itemsLateralite" :value="option.value" :key="'cote_' + index">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col">
                <label class="mt-2 mb-0" for="">Date de l’intervention</label>
                <m-form-text class="mt-0" type="text" v-model="patient.pa_dateoperation"></m-form-text>
              </div>
            </div>
            <div>
              <label class="mt-2 mb-0" for="pa_comment">Remarque</label>
              <m-form-text id="pa_comment" name="pa_comment" class="mt-0" type="textarea"
                placeholder="Commentaire" v-model="patient.pa_comment"></m-form-text>
            </div>
            <div class="text-right mt-3">
              <button class="btn btn-primary" @click="calculate">Prédire</button>
            </div>
          </div>
        </div>
        <div class="row mt-4" style="padding-bottom: 100px">
          <div class="col">
            <h3>RÉSULTATS</h3>
            <table class="table">
              <thead>
                <tr>
                  <th>Tibia</th>
                  <th class="text-center">ML</th>
                  <th class="text-center">AP</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Tibia estimé</td>
                  <td class="text-center">{{ patient.pa_probaTibiaML }}</td>
                  <td class="text-center">{{ patient.pa_probaTibiaAP }}</td>
                </tr>
                <tr>
                  <td>Taille recommandée</td>
                  <td class="text-center">{{ patient.pa_probaTailleTibiaML }}</td>
                  <td class="text-center">{{ patient.pa_probaTailleTibiaAP }}</td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th>Fémur</th>
                  <th class="text-center">ML</th>
                  <th class="text-center">AP</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Fémur estimé</td>
                  <td class="text-center">{{ patient.pa_probaFemurML }}</td>
                  <td class="text-center">{{ patient.pa_probaFemurAP }}</td>
                </tr>
                <tr>
                  <td>Taille recommandée</td>
                  <td class="text-center">{{ patient.pa_probaTailleFemurML }}</td>
                  <td class="text-center">{{ patient.pa_probaTailleFemurAP }}</td>
                </tr>
              </tbody>
            </table>
            <div class="text-right">
              <button class="btn btn-primary" @click="save">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-message-dialog v-model="messageErreur" title="Erreur" :text="messageErreurTxt"></m-message-dialog>
  </div>
</template>

<script>
export default {
  name: "edit-genou",
  components: {},
  data() {
    return {
      patient: { pa_age: 50, pa_weight: 97, pa_height: 175, pa_sex: 1, pa_dateoperation: "", pa_comment: "" },
      results: {},
      itemsSex: [
        { value: 0, text: "-" },
        { value: 1, text: "Homme" },
        { value: 2, text: "Femme" }
      ],
      itemsLateralite: [
        { value: "", text: "-" },
        { value: "right", text: "Droit" },
        { value: "left", text: "Gauche" }
      ],
      messageErreurTxt: "",
      messageErreur: false
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    // console.log("this.$route.path", this.$route.path);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    await this.loadPatient();
    this.calculate();
  },
  watch: {},
  computed: {},
  methods: {
    async loadPatient() {
      // load patient pour récupérer les pa_tools
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/patients/" + this.$route.params.id);
      this.patient = response.data.data;
      let pa_birthdate = "",
        pa_dateoperation = "";
      if (this.patient.pa_birthdate !== "0000-00-00" && this.$dayjs(this.patient.pa_birthdate, "YYYY-MM-DD").isValid())
        pa_birthdate = this.$dayjs(this.patient.pa_birthdate, "YYYY-MM-DD").format("DD/MM/YYYY");
      if (this.patient.pa_dateoperation !== "0000-00-00" && this.$dayjs(this.patient.pa_dateoperation, "YYYY-MM-DD").isValid())
        pa_dateoperation = this.$dayjs(this.patient.pa_dateoperation, "YYYY-MM-DD").format("DD/MM/YYYY");
      this.patient.pa_birthdate = pa_birthdate;
      if (!pa_dateoperation) pa_dateoperation = this.$dayjs().format("DD/MM/YYYY");
      this.patient.pa_dateoperation = pa_dateoperation;
    },
    async save() {
      let pa_dateoperation = "0000-00-00";
      let ok = true;
      this.messageErreurTxt = "";
      // if (this.patient.pa_dateoperation) {
      pa_dateoperation = this.$dayjs(this.patient.pa_dateoperation, "DD[/]MM[/]YYYY", "fr");
      if (!pa_dateoperation.isValid()) {
        ok = false;
        this.messageErreurTxt += "<br/>Date de l’intervention non valide. Le bon format est : JJ/MM/AAAA";
        this.messageErreur = true;
      } else {
        // console.log("pa_dateoperation", pa_dateoperation);
        this.patient.pa_dateoperation = pa_dateoperation.format("YYYY-MM-DD");
      }
      // }
      if (ok) {
        let data = {
          pa_type: "genou",
          pa_name: this.patient.pa_name,
          pa_age: this.patient.pa_age,
          pa_lateralite: this.patient.pa_lateralite,
          pa_dateoperation: this.patient.pa_dateoperation,
          pa_comment: this.patient.pa_comment,
          pa_weight: this.patient.pa_weight,
          pa_height: this.patient.pa_height,
          pa_sex: this.patient.pa_sex,
          pa_probaTibiaML: this.patient.pa_probaTibiaML,
          pa_probaTibiaAP: this.patient.pa_probaTibiaAP,
          pa_probaTailleTibiaML: this.patient.pa_probaTailleTibiaML,
          pa_probaTailleTibiaAP: this.patient.pa_probaTailleTibiaAP,
          pa_probaFemurML: this.patient.pa_probaFemurML,
          pa_probaFemurAP: this.patient.pa_probaFemurAP,
          pa_probaTailleFemurML: this.patient.pa_probaTailleFemurML,
          pa_probaTailleFemurAP: this.patient.pa_probaTailleFemurAP
        };

        this.cancelTokenSource = this.$axios.CancelToken.source();
        let pa_id = 0;
        if (this.patient.pa_id) {
          let response = await this.$axios.put(this.$config.server_url + "/api/1.0/patients/" + this.patient.pa_id, data, {
            cancelToken: this.cancelTokenSource.token,
            headers: {
              // "Content-Type": "multipart/form-data"
            }
          });
          // console.log("🚀 ~ save ~ response:", response);
          pa_id = response.data.data.pa_id;
        } else {
          let response = await this.$axios.post(this.$config.server_url + "/api/1.0/patients", data, {
            cancelToken: this.cancelTokenSource.token,
            headers: {
              // "Content-Type": "multipart/form-data"
            }
          });
          pa_id = response.data.data.pa_id;
          // console.log("🚀 ~ save ~ response:", response);
        }
        this.$router.push("/resultgenou/" + pa_id).catch(err => {});
      }
    },
    changeTabbar(where) {
      if (where == "patients") {
        this.showPassed = false;
      }
    },
    changeActivite(where) {
      // this.$store.commit("set_current_active", evt);
      // this.$router.push("/" + evt).catch(err => {});
      if (where === "hanche") {
        this.showPassed = false;
        this.$router.push("/patients").catch(err => {});
      } else {
        this.$router.push("/" + where).catch(err => {});
      }
    },
    reloadApp() {
      window.location.reload();
    },
    async finish() {
      this.$router.push("/genou").catch(err => {});
    },
    calculate() {
      // console.log("calculate");
      // Récupérer les valeurs des champs
      let age = this.patient.pa_age * 1;
      let weight = this.patient.pa_weight * 1;
      let height = this.patient.pa_height * 1;
      let gender = this.patient.pa_sex * 1 == 1 ? "male" : "female";

      let coeffGender = 1;
      if (gender === "male") {
        coeffGender = 0;
      }

      const tibiaAP = [38, 40.5, 43, 45.5, 48, 50.5, 53, 55.5, 58];
      const tibiaML = [56.5, 60, 63.5, 67, 70.5, 74, 77.5, 81, 85];
      const femurAP = [50, 53, 56, 58, 60, 62, 65, 68, 71, 74];
      const femurML = [54, 57, 60, 62, 64, 66, 69.5, 73, 76, 79];

      let tibiaPredAP = 16.69 + 0.04 * age + 0.17 * height + 0.02 * weight - 3.05 * coeffGender;
      let tibiaPredML = 3.5 + 26.02 + 0.04 * age + 0.26 * height - 3.76;
      let femurPredAP = -2.67 + 28.77 + 0.23 * height - 2.88 * coeffGender;
      let femurPredML = -2 * 2.77 + 38.23 + 0.21 * height - 3.1 * coeffGender;

      function closest(valeur, tableau) {
        return tableau.reduce((a, b) => {
          let aDiff = Math.abs(a - valeur);
          let bDiff = Math.abs(b - valeur);

          if (aDiff == bDiff) {
            return a > b ? a : b;
          } else {
            return bDiff < aDiff ? b : a;
          }
        });
      }

      let tibiaTailleAP = tibiaAP.indexOf(closest(tibiaPredAP, tibiaAP));
      let tibiaTailleML = tibiaML.indexOf(closest(tibiaPredML, tibiaML));
      let femurTailleAP = femurAP.indexOf(closest(femurPredAP, femurAP));
      let femurTailleML = femurML.indexOf(closest(femurPredML, femurML));

      if (tibiaTailleML > 8) {
        tibiaTailleML = 8;
      }
      if (tibiaTailleAP > 8) {
        tibiaTailleAP = 8;
      }
      if (femurTailleAP > 9) {
        femurTailleAP = 9;
      }
      if (femurTailleML > 9) {
        femurTailleML = 9;
      }
      if (tibiaTailleML < 0) {
        tibiaTailleML = 0;
      }
      if (tibiaTailleAP < 0) {
        tibiaTailleAP = 0;
      }
      if (femurTailleAP < 0) {
        femurTailleAP = 0;
      }
      if (femurTailleML < 0) {
        femurTailleML = 0;
      }

      // Afficher les résultats
      this.patient.pa_probaTibiaML = tibiaPredML.toFixed(1) + "mm";
      this.patient.pa_probaTailleTibiaML = tibiaTailleML;
      this.patient.pa_probaTibiaAP = tibiaPredAP.toFixed(1) + "mm";
      this.patient.pa_probaTailleTibiaAP = tibiaTailleAP;
      this.patient.pa_probaFemurML = femurPredML.toFixed(1) + "mm";
      this.patient.pa_probaTailleFemurML = femurTailleML;
      this.patient.pa_probaFemurAP = femurPredAP.toFixed(1) + "mm";
      this.patient.pa_probaTailleFemurAP = femurTailleAP;

      this.patient = { ...this.patient };
    }
  }
};
</script>

<style scoped lang="scss">
.m-form-checkbox {
  margin-bottom: 0;
}

.cguwin {
  position: fixed;
  background-color: white;
  border: 1px solid black;
  top: 5%;
  height: 90%;
  width: 90%;
  left: 5%;
  z-index: 10001;
  padding: 20px;

  // overflow: auto;
  .btn-jaccepte {
    position: absolute;
    bottom: 5px;
  }
}

.cguwin-content {
  overflow: auto;
}

@media (min-width: 576px) {
  .helpwin {}
}

@media (min-width: 768px) {
  .helpwin {}
}

.h-100vh {
  height: 100vh;
}
</style>
